import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as list from '../list'

/** TODO:  */
@ngCore.Component({
  imports: [list.Component],
  selector: 'atn-standard-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.common.value.Raw} */
  public readonly valueSg = ngCore.input.required<ents.core.common.value.Raw>({
    alias: 'value',
  })
}
